import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {KahpooReverse} from '../models/kahpooReverse.model';
import { User } from '../models/user.model';
import { WavePayoutInfo } from '../models/wavePayoutInfo.model';
@Injectable({
  providedIn: 'root'
})
export class KahpooReverseService {

  constructor(private http: HttpClient) { }
  getKahpooReverse(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse`);
  }

  getAllKahpooReverseResersement(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/reversement`);
  }

  getAllKahpooReversementEnCours(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/reversementEnCours`);
  }

  getAllKahpooReversementTermine(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/reversementTermine`);
  }

  getAllKahpooCommission(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/commission`);
  }

  getAllSeller(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/seller`);
  }

  getAllKahpooReverseRemboursement(): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/remboursement`);
  }

  findByDebitedWallet(id: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/wallet/` + id);
  }

  findByUser(id: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/user/` + id);
  }

  findUserCurrentReverse(id: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/userCurrentReverse/` + id);
  }

  findUserReversementDone(id: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/reversementDone/` + id);
  }

  findUserReversementVentes(id: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/ventes/` + id);
  }

  findUserNewReversement(id: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpooReverse/newReversement/` + id);
  }

  saveKahpooReverse(KahpooReverse: KahpooReverse) {
    return this.http.post<any>(`${environment.url}/kahpooReverse`, KahpooReverse);
  }
  getidKahpooReverse(idA: number) {
    return this.http.get(`${environment.url}/kahpooReverse/` + idA);
  }

  updateKahpooReverse(KahpooReverse: KahpooReverse) {
    return this.http.put<any>(`${environment.url}/kahpooReverse/` + KahpooReverse.id, KahpooReverse);
  }

  validReversement(KahpooReverse: KahpooReverse) {
    return this.http.put<any>(`${environment.url}/kahpooReverse/valid/` + KahpooReverse.id, KahpooReverse);
  }

  validReversementTest(KahpooReverse: KahpooReverse) {
    return this.http.put<any>(`${environment.url}/kahpooReverse/validTest/` + KahpooReverse.id, KahpooReverse);
  }

  validOrangeReversementNew(KahpooReverse: KahpooReverse) {
    return this.http.put<any>(`${environment.url}/orange/reverseWithOrange/`+ KahpooReverse.id, KahpooReverse);
  }

  validOrangeReversement(KahpooReverse: number) {
    return this.http.put<any>(`${environment.url}/orange/reverseWithOrange`, KahpooReverse);
  }

  reversementByOrangeMoney(KahpooReverse: number) {
    return this.http.put<any>(`${environment.url}/orange/reverse `, KahpooReverse);
  }

  testOrangeReversement() {
    return this.http.post<any>(`${environment.url}/orange/cashinTest`, null);
  }

  deleteKahpooReverse(idA: number) {
    return this.http.delete(`${environment.url}/kahpooReverse/` + idA);
  }

  updateUserReverseNumber11(id: number, newPhoneNumber: string): Observable<User> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    const params = new HttpParams()
      .set('id', id.toString())
      .set('newPhoneNumber', newPhoneNumber);

    return this.http.put<User>(`${environment.url}/reverse-number`, params, { headers });
  }

  updateUserReverseNumber(sessionId: string, id: any, paymentMethod:string, newPhoneNumber: string): Observable<User> {
    const headers = new HttpHeaders({ 'kapo_session_id': sessionId });
    const params = new HttpParams()
                        .set('id', id)
                        .set('paymentMethod', paymentMethod)
                        .set('newPhoneNumber', newPhoneNumber);

    return this.http.put<User>(`${environment.url}/user/reverse-number`, null, { headers, params });
  }

}
